<template>
  <div>
    <TextFormGroup
        :value="value.ad_unit_path"
        name="ad_unit_path"
        label="Ad Unit Path"
        :error="(errors.ad_unit_path || [])[0]"
        @input="emit('ad_unit_path', $event)"
    />
    <TextFormGroup
        :value="value.element_id"
        name="element_id"
        label="Element ID"
        :error="(errors.element_id || [])[0]"
        @input="emit('element_id', $event)"
    />
  </div>
</template>

<script>
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    },
  }
}
</script>
